import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { ObjContext } from "./context";

export class Tower extends UnitType {
    readonly id = "tower";
    readonly displayName = "Tower";
    description() { return "Repels cultists."; }
    maxCooldown() { return 0; }
    make() { return new GameObj("neutral", "tower"); }
}
